import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  size?: 'lg' | 'md';
  variant?: 'gold' | 'navy';
  className?: string;
  href?: string;
  target?: React.HTMLAttributeAnchorTarget;
}
export function CTAButton({
  children,
  size = 'lg',
  variant = 'gold',
  className = '',
  href = '#pricing',
  target = '_self'
}: CTAButtonProps) {
  const base = 'inline-flex items-center justify-center text-center font-display font-extrabold rounded-xl transition-all duration-200 shadow-lg active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40';
  const sizes = {
    lg: 'text-lg sm:text-xl px-8 py-5 w-full sm:w-auto',
    md: 'text-base px-6 py-4 w-full'
  };
  const variants = {
    gold: 'bg-gold text-navy-deep hover:bg-gold-soft hover:shadow-gold/40 hover:-translate-y-0.5',
    navy: 'bg-navy text-white hover:bg-navy-mid hover:-translate-y-0.5'
  };
  return <a href={href} target={target} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-191" data-mp="2d8v6r7ipgrac">
      {children}
    </a>;
}
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}
export function Section({
  children,
  className = '',
  id
}: SectionProps) {
  return <section id={id} className={`w-full px-5 sm:px-6 ${className}`} data-id="element-192" data-mp="1zmoc1ib3d33b">
      <div className="mx-auto w-full max-w-5xl" data-id="element-193" data-mp="1uov3wjq89z0e">{children}</div>
    </section>;
}
export function Avatar({
  initials
}: {
  initials: string;
}) {
  const avatarImages: Record<string, {
    src: string;
    alt: string;
  }> = {
    MG: {
      src: 'https://cdn.magicpatterns.com/uploads/2x2bdjgdrE5DNc5STiX9iN/1.png',
      alt: 'Martín G.'
    },
    LP: {
      src: 'https://cdn.magicpatterns.com/uploads/ryHhHzPWokuUdr61M3cVUP/7.png',
      alt: 'Laura P.'
    },
    RM: {
      src: 'https://cdn.magicpatterns.com/uploads/8kN3qrhKmob7f4tbiKAYDC/5.png',
      alt: 'Roberto M.'
    },
    CR: {
      src: 'https://cdn.magicpatterns.com/uploads/6XVeGYHhtWk3q9ReKtxizC/8].png',
      alt: 'Cecilia R.'
    },
    SC: {
      src: 'https://cdn.magicpatterns.com/uploads/mftgiBPk3kEzWi67F6Hd4q/2.png',
      alt: 'Sofía C.'
    },
    PA: {
      src: 'https://cdn.magicpatterns.com/uploads/6CTVYwESYtgDTStBR1E4PA/4.png',
      alt: 'Pablo A.'
    }
  };
  const avatar = avatarImages[initials];
  if (avatar) {
    return <img src={avatar.src} alt={avatar.alt} className="h-12 w-12 shrink-0 rounded-full object-cover" data-id="element-194" data-mp="o9yib1xpbh88" />;
  }
  return <div aria-hidden="true" className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-navy font-display font-bold text-gold-soft" data-id="element-195" data-mp="1c1lz2r191bws">
      {initials}
    </div>;
}